module.exports = __webpack_public_path__ + "static/media/banner-games-bg.32f7a7ca.svg";